import SideBarItems from '../SideNavigationPanel/SideBarItems';
import { shouldBeVisible } from '../SideNavigationPanel/utils';

const MAX_PRIMARY_ITEMS = 6;

export const getEnabledItems = (
  items: typeof SideBarItems,
  featureFlags: Record<string, boolean>,
  roles: string[] | undefined
) =>
  items.filter(item =>
    shouldBeVisible({
      featureFlags: item.isEnabled.featureFlags,
      roles: item.isEnabled.roles,
      actualFeatureFlags: featureFlags,
      actualRoles: roles,
      excludedRoles: item.isEnabled.excludedRoles,
      excludedFeatureFlags: item.isEnabled.excludedFeatureFlags,
      requiredFeatureFlags: item.isEnabled.requiredFeatureFlags,
      customCheck: item.isEnabled.customCheck
    })
  );

export const splitNavigationItems = (items: typeof SideBarItems) => ({
  primaryNavItems: items.slice(0, MAX_PRIMARY_ITEMS),
  secondaryNavItems: items.slice(MAX_PRIMARY_ITEMS)
});
